const unidades = [
  "",
  "um",
  "dois",
  "três",
  "quatro",
  "cinco",
  "seis",
  "sete",
  "oito",
  "nove",
  "dez",
  "onze",
  "doze",
  "treze",
  "quatorze",
  "quinze",
  "dezesseis",
  "dezessete",
  "dezoito",
  "dezenove",
];

const dezenas = [
  "",
  "",
  "vinte",
  "trinta",
  "quarenta",
  "cinquenta",
  "sessenta",
  "setenta",
  "oitenta",
  "noventa",
];

const centenas = [
  "",
  "cento",
  "duzentos",
  "trezentos",
  "quatrocentos",
  "quinhentos",
  "seiscentos",
  "setecentos",
  "oitocentos",
  "novecentos",
];

function numeroParaExtenso(n: number): string {
  if (n === 0) return "zero";
  if (n === 100) return "cem";

  const partes: string[] = [];

  // trilhões
  if (n >= 1_000_000_000_000) {
    const trilhoes = Math.floor(n / 1_000_000_000_000);
    partes.push(
      `${numeroParaExtenso(trilhoes)} ${
        trilhoes === 1 ? "trilhão" : "trilhões"
      }`
    );
    n %= 1_000_000_000_000;
  }

  // bilhões
  if (n >= 1_000_000_000) {
    const bilhoes = Math.floor(n / 1_000_000_000);
    partes.push(
      `${numeroParaExtenso(bilhoes)} ${bilhoes === 1 ? "bilhão" : "bilhões"}`
    );
    n %= 1_000_000_000;
  }

  // milhões
  if (n >= 1_000_000) {
    const milhoes = Math.floor(n / 1_000_000);
    partes.push(
      `${numeroParaExtenso(milhoes)} ${milhoes === 1 ? "milhão" : "milhões"}`
    );
    n %= 1_000_000;
  }

  // milhares
  if (n >= 1000) {
    const milhar = Math.floor(n / 1000);
    partes.push(milhar === 1 ? "mil" : `${numeroParaExtenso(milhar)} mil`);
    n %= 1000;
  }

  // centenas
  if (n >= 100) {
    const cent = Math.floor(n / 100);
    partes.push(centenas[cent]);
    n %= 100;
  }

  // dezenas
  if (n >= 20) {
    const dez = Math.floor(n / 10);
    partes.push(dezenas[dez]);
    n %= 10;
  }

  // unidades (0–19)
  if (n > 0) {
    partes.push(unidades[n]);
  }

  return partes.join(" e ");
}

/** ============================
 *  NOVO: valor monetário por extenso
 * ============================ */
function nomeMoedaPt(moeda: string, inteiro: number): string {
  const singular = inteiro === 1;

  switch (moeda.toUpperCase()) {
    case "BRL":
      return singular ? "real" : "reais";
    case "USD":
      return singular ? "dólar" : "dólares";
    case "EUR":
      return singular ? "euro" : "euros";
    default:
      return singular ? "unidade" : "unidades";
  }
}

/**
 * Converte um valor monetário em texto em português,
 * TROCA apenas a "moeda" (real, dólar, euro, etc.).
 *
 * Ex.: numeroMonetarioParaExtenso(1234, "USD")
 *      -> "mil duzentos e trinta e quatro dólares"
 *
 * Obs.: usa apenas a parte inteira (sem centavos).
 */
export function numeroMonetarioParaExtenso(
  valor: number,
  moeda: string = "BRL"
): string {
  const inteiro = Math.floor(Math.abs(valor)); // garante inteiro positivo
  const extensoNumero = numeroParaExtenso(inteiro);
  const nome = nomeMoedaPt(moeda, inteiro);
  return `${extensoNumero} ${nome}`;
}

export default numeroParaExtenso;
